/* Add functionality to the question headers */
const questionHeaders = document.querySelectorAll('.faq-question');
questionHeaders.forEach(function (questionHeader) {
  questionHeader.addEventListener('click', function () {
    this.classList.toggle('active');
    const answerContainer = this.nextElementSibling;
    if (answerContainer.style.maxHeight) {
      answerContainer.style.maxHeight = null;
      answerContainer.classList.remove('active');
    } else {
      answerContainer.style.maxHeight = answerContainer.scrollHeight + 'px';
      answerContainer.classList.add('active');
    }
  });
});
